import styled, { css } from 'styled-components';

import { pxToRem } from '../../../utils/styles';

export const PromoCodeContainer = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    margin: ${pxToRem(40)} 0;
    gap: ${pxToRem(8)};
  }
`;

export const Row = styled.div`
  &&& {
    display: flex;
    align-items: flex-end;
    gap: ${pxToRem(16)};
    height: ${pxToRem(64)};
  }
`;

export const PromoCodeAction = styled.div<{ $setMarginBottom: boolean }>`
  &&& {
    margin-bottom: ${pxToRem(4)};
    ${({ $setMarginBottom }) =>
      $setMarginBottom &&
      css`
        margin-bottom: ${pxToRem(8)};
      `}
  }
`;

export const ValidationError = styled.div`
  &&& {
    margin-top: ${pxToRem(5)};
  }
`;
export const InputWrapper = styled.div`
  &&& {
    flex-basis: 70%;
  }
`;
